import * as actionTypes from 'constants/ActionTypes';

export function getVesselOrders() {
    return {
        type: actionTypes.GET_VESSEL_ORDERS,
    };
}

export function createVesselOrders(items, user) {
    return {
        type: actionTypes.CREATE_VESSEL_ORDERS,
        items,
        user,
    };
}

export function clearMessage(vesselOrderKey) {
    return {
        type: actionTypes.CLEAR_VESSEL_ORDER_MESSAGE,
        vesselOrderKey,
    };
}

export function updateVesselOrder(numberOrder, newVesselOrder) {
    return {
        type: actionTypes.UPDATE_VESSEL_ORDER,
        numberOrder,
        newVesselOrder,
    };
}

export function addVesselOrder() {
    return {
        type: actionTypes.ADD_VESSEL_ORDER,
    };
}

export function removeLastVesselOrder() {
    return {
        type: actionTypes.REMOVE_LAST_VESSEL_ORDER,
    };
}

export function updateVesselOrderUser(user) {
    return {
        type: actionTypes.UPDATE_VESSEL_ORDER_USER,
        user,
    };
}

export function removeAllVesselOrders() {
    return {
        type: actionTypes.REMOVE_ALL_VESSEL_ORDERS,
    };
}

export function resetVesselOrders() {
    return {
        type: actionTypes.RESET_VESSEL_ORDERS,
    };
}




// WEBPACK FOOTER //
// ./app/actions/vessels/orders.js